module.exports = __webpack_public_path__ + "img/组 4.18930fb9.webp";